import { __decorate } from "tslib";
import { Group, Matrix4 } from "three";
import { Config } from "../../Config/Config.js";
import { Save, SaveChild } from "../../Core/Save.js";
import { bindedModelBase } from "../../Models/BindedModel.js";
import { DraggablePoint } from "../Primitive/DraggablePoint.js";
import { LinePointToPoint2 } from "../Primitive/LinePointToPoint2.js";
import { Apex } from "./Apex.js";
export class ThirdLine extends Group {
    get axisApexA() {
        return this.A.position;
    }
    get axisApexB() {
        return this.B.position;
    }
    constructor(viewType, reference, moving, side, referenceType, planType) {
        super();
        this.minDistance_A_B = 6;
        this.name = 'Third line';
        this._viewType = viewType;
        this._reference = reference;
        this._moving = moving;
        this.add(this.A = new DraggablePoint('A', viewType, Config.thirdLine_colorHex), this.B = new DraggablePoint('B', viewType, Config.thirdLine_colorHex), this.C = new DraggablePoint('C', viewType, Config.thirdLine_colorHex), this.AB_Line = new LinePointToPoint2('O1_O2_Line', viewType, Config.thirdLine_colorHex, this.A, this.B), this._apex1 = new Apex("Apex Proximal", viewType, reference, this, side, referenceType, planType), this._apex2 = new Apex("Apex Distal", viewType, this, moving, side, referenceType, planType));
        this.apexes = [this._apex1, this._apex2];
        this._apex1.add(this.line1 = new LinePointToPoint2('ApexLine1', viewType, Config.thirdLine_colorHex, this._apex1.hexagon, this.C, Config.apex_line_gap_size, Config.apex_dash_size, Config.apex_line_width));
        this._apex2.add(this.line2 = new LinePointToPoint2('ApexLine2', viewType, Config.thirdLine_colorHex, this._apex2.hexagon, this.C, Config.apex_line_gap_size, Config.apex_dash_size, Config.apex_line_width));
        this.A.bindEvent("onDragMove", (args) => {
            if (bindedModelBase.syncAnatomicalAxis)
                return;
            this.preventMinDistance(args.position, this.B.position, this.minDistance_A_B);
            this.C.position.lerpVectors(args.position, this.B.position, 0.5);
        });
        this.B.bindEvent("onDragMove", (args) => {
            if (bindedModelBase.syncAnatomicalAxis)
                return;
            this.preventMinDistance(args.position, this.A.position, this.minDistance_A_B);
            this.C.position.lerpVectors(this.A.position, args.position, 0.5);
        });
        this.C.bindEvent("onDragMove", (args) => {
            if (bindedModelBase.syncAnatomicalAxis)
                return;
            const transl = args.position.clone().sub(this.C.position);
            this.A.position.add(transl);
            this.B.position.add(transl);
        });
        this.initPosition(reference, moving);
    }
    initPosition(ref, mov) {
        this.A.position.lerpVectors(ref.center.position, ref.Ac.position, 0.5);
        this.B.position.lerpVectors(mov.center.position, mov.Ac.position, 0.5);
        this.C.position.lerpVectors(this.A.position, this.B.position, 0.5);
    }
    update() {
        this._apex1.visible = this._apex1.update();
        this._apex2.visible = this._apex2.update();
        this.parent.dispatchEvent({ type: 'updated' });
    }
    updateAxis(axis1, axis2) {
        this._apex1.proximalAxis = axis1;
        this._apex2.proximalAxis = axis2;
        this.update();
    }
    preventMinDistance(position, point, minDistance) {
        const distance = position.distanceTo(point);
        if (distance < minDistance) {
            const dir = position.clone().sub(point);
            position.copy(point.clone().add(dir.setLength(minDistance)));
        }
    }
    translateAllPoints(translation) {
        this._apex1.hexagon.position.add(translation);
        this._apex2.hexagon.position.add(translation);
        this.A.position.add(translation);
        this.B.position.add(translation);
        this.C.position.add(translation);
    }
    rotateAllPoints(angle, rotationCenter) {
        const matrix = new Matrix4();
        matrix.makeRotationZ(angle);
        this._apex1.hexagon.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
        this._apex2.hexagon.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
        this.A.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
        this.B.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
        this.C.position.sub(rotationCenter).applyMatrix4(matrix).add(rotationCenter);
    }
    reset() {
        this.initPosition(this._reference, this._moving);
    }
}
__decorate([
    Save("position")
], ThirdLine.prototype, "A", void 0);
__decorate([
    Save("position")
], ThirdLine.prototype, "B", void 0);
__decorate([
    Save("position")
], ThirdLine.prototype, "C", void 0);
__decorate([
    SaveChild()
], ThirdLine.prototype, "_apex1", void 0);
__decorate([
    SaveChild()
], ThirdLine.prototype, "_apex2", void 0);
//# sourceMappingURL=ThirdLine.js.map